var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tab-item" },
    [
      !_vm.item.component || !_vm.item.component.content
        ? _c("div", { staticClass: "tab-item-no-content" }, [
            _c("p", [
              _vm._v(" " + _vm._s(_vm.value || _vm.default_value) + " "),
            ]),
          ])
        : _c(
            _vm.item.component.content,
            _vm._b(
              {
                tag: "component",
                attrs: { value: _setup.form, mapId: _vm.mapId },
                on: {
                  change: function ($event) {
                    _setup.form = $event
                  },
                },
              },
              "component",
              _setup.attrs,
              false
            )
          ),
      _vm.default_value != null
        ? _c("div", { staticClass: "full-width" }, [
            _c("hr", { staticClass: "map-divider" }),
            _c(
              "button",
              {
                staticClass: "map-button text-center full-width",
                attrs: {
                  disabled:
                    _setup.form == null || _setup.form == _vm.default_value,
                },
                on: {
                  click: function ($event) {
                    return _setup.onSetDefaultValue()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("map.style-control.back-to-default")) +
                    " "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }